import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SquareCorners from './SquareCorners';
import ClientProvider from './client';
export default createDemo(import.meta.url, SquareCorners, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/paper/demos/square-corners/SquareCorners.tsx",
    "fileName": "SquareCorners.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Stack from '@mui/material/Stack';\nimport Paper from '@mui/material/Paper';\nimport { styled } from '@mui/material/styles';\n\nconst DemoPaper = styled(Paper)(({ theme }) => ({\n  width: 120,\n  height: 120,\n  padding: theme.spacing(2),\n  ...theme.typography.body2,\n  textAlign: 'center',\n}));\n\nexport default function SquareCorners() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <DemoPaper square={false}>rounded corners</DemoPaper>\n      <DemoPaper square>square corners</DemoPaper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 20,
        "focusedLines": 2,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Stack from '@mui/material/Stack';\nimport Paper from '@mui/material/Paper';\nimport { styled } from '@mui/material/styles';\n\nconst DemoPaper = styled(Paper)(({ theme }) => ({\n  width: 120,\n  height: 120,\n  padding: theme.spacing(2),\n  ...theme.typography.body2,\n  textAlign: 'center',\n}));\n\nexport default function SquareCorners() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <DemoPaper square={false}>rounded corners</DemoPaper>\n      <DemoPaper square>square corners</DemoPaper>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "DemoPaper"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "square"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-bool",
                "false"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">rounded corners</",
              [
                "span",
                "pl-c1 di-jsx",
                "DemoPaper"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "DemoPaper"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "square"
              ],
              ">square corners</",
              [
                "span",
                "pl-c1 di-jsx",
                "DemoPaper"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 20,
    "focusedLines": 2,
    "collapsible": true,
    "externals": [
      "@mui/material/Stack",
      "@mui/material/Paper",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
